export const MANAGER_SUMMARY_LABELS = {
    commission: 'Баллы',
    shipmentCount: 'Отгрузок',
    shipments: 'Отгрузки',
} as const
